import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import sysytem from "./modules/sysytem";
import mistakes from "./modules/mistakes";
import getters from "./getters";
import persistedState from "vuex-persistedstate";
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    sysytem,
    mistakes
  },
  getters,
  plugins: [persistedState({ storage: window.localStorage })]
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js